<template>
  <form @submit.prevent="nextStep">
    <div class="form-group registration-steps">
      <span class="badge badge-secondary p-2">1</span>
      - - -
      <span class="badge badge-warning p-2">2 - Persoonsgegevens</span>
      - - -
      <span class="badge badge-secondary p-2">3</span>
    </div>

    <fieldset class="form-group mt-2">
      <legend class="legend-label pt-0">Aanhef</legend>
      <div class="form-check form-check-inline">
        <input v-model="gender" class="form-check-input" type="radio" name="gender" id="radio-male" value="0">
        <label class="form-check-label" for="radio-male">Dhr</label>
      </div>
      <div class="form-check form-check-inline">
        <input v-model="gender" class="form-check-input" type="radio" name="gender" id="radio-female" value="1">
        <label class="form-check-label" for="radio-female">Mevr.</label>
      </div>
    </fieldset>

    <div class="form-group">
      <label for="first-name">Voornaam</label>
      <input
        id="first-name"
        name="first-name"
        type="text"
        class="form-control"
        :class="{'is-invalid': $v.first_name.$error}"
        v-model="first_name"
        @blur="$v.first_name.$touch()"
        placeholder="Voornaam"
      >
      <span v-if="$v.first_name.$error" class="invalid-feedback" role="alert">
        <strong>Vul a.u.b. uw voornaam in.</strong>
      </span>
    </div>

    <div class="form-row">
      <div class="col-md-4">
        <label for="infix-name">Tussenv.</label>
        <input
          id="infix-name"
          name="infix-name"
          type="text"
          class="form-control"
          v-model="infix_name"
          placeholder="Tussenv."
        >
      </div>
      <div class="col-md-9">
        <label for="last-name">Achternaam</label>
        <input
          id="last-name"
          name="last-name"
          type="text"
          class="form-control"
          :class="{'is-invalid': $v.last_name.$error}"
          v-model="last_name"
          @blur="$v.last_name.$touch()"
          placeholder="Achternaam"
        >
        <span v-if="$v.last_name.$error" class="invalid-feedback" role="alert">
          <strong>Vul a.u.b. uw achternaam in.</strong>
        </span>
      </div>
    </div>

    <div class="form-group mt-2">
      <label for="phone">Telefoonnummer</label>
      <input
        id="phone"
        name="phone"
        type="text"
        class="form-control"
        :class="{'is-invalid': $v.phone.$error}"
        v-model="phone"
        @blur="$v.phone.$touch()"
        placeholder="Telefoonnummer"
      >
      <span v-if="$v.phone.$error" class="invalid-feedback" role="alert">
        <strong>Vul a.u.b. uw telefoonnummer in (zonder streepjes).</strong>
      </span>
    </div>

    <div class="row justify-content-center mt-md-5">
      <div class="col-md-13">
        <button
          type="submit"
          class="btn btn-oldevuuren w-100 btn-round"
          :disabled="$v.$invalid"
          :class="{'disabled cursor-not-allowed': $v.$invalid}"
        >
          Naar inloggegevens
        </button>
      </div>

      <div class="row align-content-center mt-md-2">
        <div class="col-md-13">
          <span class="link" @click="previousStep"><font-awesome-icon class="font-awesome-icon" icon="chevron-left"/> Terug</span>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import { minLength, required, numeric } from 'vuelidate/lib/validators'
  import { SAVE_REGISTRATION_DATA } from '../../../store/types'

  export default {
    props: ['nextStepParent', 'previousStepParent'],
    data() {
      return {
        first_name: '',
        infix_name: '',
        last_name: '',
        phone: '',
        gender: ''
      }
    },
    validations: {
      first_name: {
        required,
        minLen: minLength(2)
      },
      last_name: {
        required,
        minLen: minLength(2)
      },
      phone: {
        required,
        numeric,
        minLen: minLength(10)
      }
    },
    methods: {
      nextStep() {
        // Save registration data
        this.$store.dispatch(SAVE_REGISTRATION_DATA, {
          key: 'personalDetails',
          formData: {
            first_name: this.first_name,
            infix_name: this.infix_name,
            last_name: this.last_name,
            phone: this.phone,
            gender: this.gender
          }
        })

        this.nextStepParent()
      },
      previousStep() {
        // Save registration data
        this.$store.dispatch(SAVE_REGISTRATION_DATA, {
          key: 'personalDetails',
          formData: {
            first_name: this.first_name,
            infix_name: this.infix_name,
            last_name: this.last_name,
            phone: this.phone,
            gender: this.gender
          }
        })

        this.previousStepParent()
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
